import { calculateDetailAmount } from "src/utils/calculation/calculationUtils";
import { WMS1140_R01DetailDto } from "./Dto_WMS1140_R01";

/** 입고구분: 사급자재입고 — 단가 미사용(0 고정) */
export const WMS1140_INOUT_CLASS_SUBCONTRACT_MATERIAL = '170';

export const isSubcontractMaterialInoutClass = (inoutClass?: string) =>
	inoutClass === WMS1140_INOUT_CLASS_SUBCONTRACT_MATERIAL;

export const WMS1140_DETAIL_AMOUNT_FIELD_MAPPING = {
	qtyField: 'qty',
	priceField: 'cost',
	dcField: 'dcAmt',
	amountField: 'amt',
	preventNegative: true,
};

/** 사급자재입고(170)이면 단가·금액을 0 기준으로 정규화 */
export const normalizeWMS1140DetailRow = (
	row: WMS1140_R01DetailDto,
	inoutClass?: string,
): WMS1140_R01DetailDto => {
	if (!isSubcontractMaterialInoutClass(inoutClass)) {
		return calculateDetailAmount(row, WMS1140_DETAIL_AMOUNT_FIELD_MAPPING);
	}
	return calculateDetailAmount(
		{ ...row, cost: 0 },
		WMS1140_DETAIL_AMOUNT_FIELD_MAPPING,
	);
};
